/**
* DevExpress HTML/JS Reporting (designer\internal\fieldlist\_treelistFactory.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { DefaultTreeListItemFactory } from '@devexpress/analytics-core/analytics-widgets-internal';
import { ReportDesignerTreelistItem } from './_treelistItem';
export class FieldListItemFactory extends DefaultTreeListItemFactory {
    constructor(_renameInProgres) {
        super();
        this._renameInProgres = _renameInProgres;
    }
    createItem(options, path, onItemsVisibilityChanged, rtl, resolver) {
        return new ReportDesignerTreelistItem(options, path, onItemsVisibilityChanged, rtl, resolver, this._renameInProgres);
    }
}
